"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var AppBarContainer = function AppBarContainer(_ref) {
  var _classNames, _classNames2;

  var badge = _ref.badge,
      buttons = _ref.buttons,
      dark = _ref.dark,
      fixed = _ref.fixed,
      Logo = _ref.Logo,
      small = _ref.small,
      props = _objectWithoutProperties(_ref, ["badge", "buttons", "dark", "fixed", "Logo", "small"]);

  return _react.default.createElement("nav", _extends({
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, _style.default.appbar, true), _defineProperty(_classNames, _style.default._dark, dark), _defineProperty(_classNames, _style.default._fixed, fixed), _defineProperty(_classNames, _style.default._small, small), _classNames))
  }, props), _react.default.createElement("div", {
    className: _style.default.content
  }, Logo && _react.default.createElement("div", {
    className: (0, _classnames.default)((_classNames2 = {}, _defineProperty(_classNames2, _style.default.logo, true), _defineProperty(_classNames2, _style.default._badge, badge), _classNames2)),
    "data-before": badge
  }, _react.default.createElement(Logo, null)), Array.isArray(buttons) && buttons.length > 0 && _react.default.createElement("ul", {
    className: _style.default.list
  }, buttons.map(function (ReactComponent, index) {
    return _react.default.createElement("li", {
      className: _style.default.item,
      key: index
    }, ReactComponent);
  }))));
};

var _default = AppBarContainer;
exports.default = _default;